export default "__VITE_ASSET__KNUMD$$s__"